import { Layout } from 'antd';
import { StyledHeader } from './Header';

Layout.Header = StyledHeader;

export { Layout };
